import { configureStore } from '@reduxjs/toolkit';
import { persistStore } from 'redux-persist';

// Local
import persistReducer from './persistentReducer';
import middleWare from './middleware';
import devTools from './devTools';

export const store = configureStore({
  reducer: persistReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }).concat(middleWare),
  devTools,
});

const persistor = persistStore(store);

export { store as default, persistor };
